module.exports = __webpack_public_path__ + "img/Yoga1.d6f1a706.png";